<template>
    <component
:is="element"
        :href="email ? `mailto:${href}` : (isDisabled && !inertiaLink ? null : href)"
        :target="target || linkTarget"
        :title="title"
        :class="classes"
        :download="download"
        :disabled="isDisabled"
        :aria-disabled="isDisabled"
        :role="element === 'a' ? 'link' : null"
        :replace="replace"
        :type="element === 'button' ? 'button' : null"
        @click="onClick"
        @blur="onBlur"
        @mouseover="onMouseOver"
        @mouseleave="onMouseLeave"
    >
        <b-spinner v-if="loading" class="position-absolute mx-auto" :style="spinnerStyle"></b-spinner>
        <slot name="start"></slot>
        <font-awesome-icon v-if="icon && !iconRight" :icon="icon" :class="{'text-white': loading}" :style="iconWidth ? {width: iconWidth} : null"></font-awesome-icon>
        <span v-if="label || $slots.default" :class="{'ml-2': icon && !iconRight, 'mr-2': icon && iconRight, 'opacity-30': !icon && loading}">
            {{ label }}<slot></slot>
        </span>
        <font-awesome-icon v-if="icon && iconRight" :icon="icon" :class="{'text-white': loading}" :style="iconWidth ? {width: iconWidth} : null"></font-awesome-icon>
    </component>
</template>

<script>
import LinkTarget from '@/mixins/LinkTarget'

// When used within b-popover default slot, global components don't work and have to be registered again
import {BSpinner} from 'bootstrap-vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {Link as InertiaLink} from '@inertiajs/vue3'

export default {
    components: {
        BSpinner,
        FontAwesomeIcon,
        InertiaLink,
    },
    mixins: [
        LinkTarget,
    ],
    props: {
        href: String,
        component: {type: String, default: 'a'},
        title: String,
        label: String,
        icon: String,
        iconWidth: String,
        variant: {type: String, default: 'primary'},
        inertiaLink: Boolean,
        email: Boolean,
        download: Boolean,
        disabled: Boolean,
        loading: Boolean,
        replace: Boolean,
        target: String,
        breakText: Boolean,
        iconRight: Boolean,
    },
    emits: ['click', 'blur', 'mouseover', 'mouseleave'],
    computed: {
        isDisabled() {
            return this.disabled || this.loading
        },
        element() {
            return this.inertiaLink ? 'inertia-link' : this.component
        },
        classes() {
            return {
                [`text-${this.variant}`]: this.variant,
                'disabled': this.isDisabled,
                'position-relative': this.loading,
                'text-decoration-none': !this.label && !this.$slots.default,
                'text-button': this.component === 'button',
                'text-nowrap text-truncate d-inline-block align-text-bottom mw-100': !this.breakText,
            }
        },
        spinnerStyle() {
            const spinnerSize = '0.9rem'
            return {
                left: 0,
                right: this.icon ? null : 0,
                marginInline: this.icon ? null : 'auto',
                top: `calc(50% - ${spinnerSize} / 2)`,
                width: spinnerSize,
                height: spinnerSize,
            }
        },
    },
    methods: {
        onClick (event) {
            this.$emit('click', event)
        },
        onBlur (event) {
            this.$emit('blur', event)
        },
        onMouseOver (event) {
            this.$emit('mouseover', event)
        },
        onMouseLeave (event) {
            this.$emit('mouseleave', event)
        },
    }
}
</script>
